module.exports = __webpack_public_path__ + "img/symbol_1.084d7767.png";